import { ICON_BACKGROUND, ICON_FILL, ICON_COLOR } from './colors';
import { ToolCategory } from './tools';

export const colorsByCategory = {
  [ToolCategory.Design]: {
    background: ICON_BACKGROUND[ICON_COLOR.purple],
    fill: ICON_FILL[ICON_COLOR.purple],
  },
  [ToolCategory.Video]: {
    background: ICON_BACKGROUND[ICON_COLOR.yellow],
    fill: ICON_FILL[ICON_COLOR.yellow],
  },
  [ToolCategory.Text]: {
    background: ICON_BACKGROUND[ICON_COLOR.lightGreen],
    fill: ICON_FILL[ICON_COLOR.lightGreen],
  },
  [ToolCategory.Color]: {
    background: ICON_BACKGROUND[ICON_COLOR.indigo],
    fill: ICON_FILL[ICON_COLOR.indigo],
  },
  [ToolCategory.Convert]: {
    background: ICON_BACKGROUND[ICON_COLOR.green],
    fill: ICON_FILL[ICON_COLOR.green],
  },
  [ToolCategory.PDF]: {
    background: ICON_BACKGROUND[ICON_COLOR.red],
    fill: ICON_FILL[ICON_COLOR.red],
  },
  [ToolCategory.Image]: {
    background: ICON_BACKGROUND[ICON_COLOR.magenta],
    fill: ICON_FILL[ICON_COLOR.magenta],
  },
};
